import { render, staticRenderFns } from "./reviewPay.vue?vue&type=template&id=3daf71d0&scoped=true&"
import script from "./reviewPay.vue?vue&type=script&lang=js&"
export * from "./reviewPay.vue?vue&type=script&lang=js&"
import style0 from "./reviewPay.vue?vue&type=style&index=0&id=3daf71d0&prod&lang=scss&scoped=true&"
import style1 from "./reviewPay.vue?vue&type=style&index=1&id=3daf71d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daf71d0",
  null
  
)

export default component.exports